import React, { useState, useEffect, useRef } from "react";
import EventName from "./EventName";
import "./attendeeDetails.css";
import { useNavigate } from "react-router-dom";
import SummaryComponent from "./SummaryComponent";
import { useEvent } from "./EventDetailsContext";
import "../src/assets/styles/bootstrap-4.4.1.css";
import { isAttendeeDetailsInitiated } from "./apiService";
import "../src/assets/styles/style.css";
import { QRCodeCanvas } from "qrcode.react";
import logoSrc from "./assets/ecologo.png";
import { FaRegCopy } from "react-icons/fa6";
import { BsDownload } from "react-icons/bs";
import "./ShareFormSection.css";

const AttendeeConfirmation = () => {
  const { eventDetails } = useEvent();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [showSummary, setShowSummary] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [summaryData, setsummaryData] = useState(null);
  const [toast, setToast] = useState(false);
  const canvasRef = useRef();

  const link = `https://ecoindex.ai/add-information?id=${eventDetails?.eventId}`;

  const generateImage = () => {
    const qrCanvas = canvasRef.current.querySelector("canvas");
    const qrDataUrl = qrCanvas.toDataURL("image/png", 1.0);

    const finalCanvas = document.createElement("canvas");
    finalCanvas.width = 850 * 2;
    finalCanvas.height = 1200 * 2;
    const ctx = finalCanvas.getContext("2d");

    ctx.scale(2, 2);

    const gradient = ctx.createLinearGradient(
      0,
      0,
      finalCanvas.width / 2,
      finalCanvas.height / 2
    );
    gradient.addColorStop(0, "#f0f8ff");
    gradient.addColorStop(1, "#e0f7fa");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, finalCanvas.width / 2, finalCanvas.height / 2);

    ctx.font = '32px "Montserrat", sans-serif';
    ctx.fillStyle = "#007272";
    ctx.textAlign = "center";
    ctx.font = 'italic 28px "Montserrat", sans-serif';
    ctx.fillText(
      "Please scan and share your details to",
      finalCanvas.width / 4,
      175
    );
    ctx.fillText("track carbon emissions for", finalCanvas.width / 4, 225);

    const ToFitText = (
      context,
      text,
      x,
      y,
      maxWidth,
      initialFontSize,
      minFontSize,
      lineHeight
    ) => {
      let fontSize = initialFontSize;
      context.font = `bold ${fontSize}px "Lora", serif`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && fontSize > minFontSize) {
        fontSize -= 2;
        context.font = `bold ${fontSize}px "Lora", serif`;
        textWidth = context.measureText(text).width;
      }

      if (textWidth > maxWidth) {
        const words = text.split(" ");
        let line = "";
        let newY = y;

        for (let i = 0; i < words.length; i++) {
          const testLine = line + words[i] + " ";
          const testWidth = context.measureText(testLine).width;
          if (testWidth > maxWidth && i > 0) {
            context.fillText(line, x, newY);
            line = words[i] + " ";
            newY += lineHeight;
          } else {
            line = testLine;
          }
        }
        context.fillText(line, x, newY);
      } else {
        context.fillText(text, x, y);
      }
    };

    ToFitText(
      ctx,
      eventDetails?.eventName || "Event",
      finalCanvas.width / 4,
      325,
      finalCanvas.width / 2 - 80,
      80,
      40,
      30
    );

    ctx.font = '40px "Montserrat", sans-serif';
    ctx.fillStyle = "#007272";

    const qrSize = 400;
    const qrX = (finalCanvas.width / 2 - qrSize) / 2;
    const qrY = (finalCanvas.height / 2 - qrSize) / 1.8;
    const radius = 30;
    ctx.lineWidth = 5;
    ctx.strokeStyle = "#007272";
    ctx.beginPath();
    ctx.moveTo(20 + radius, 20);
    ctx.lineTo(finalCanvas.width / 2 - 20 - radius, 20);
    ctx.quadraticCurveTo(
      finalCanvas.width / 2 - 20,
      20,
      finalCanvas.width / 2 - 20,
      20 + radius
    );
    ctx.lineTo(
      finalCanvas.width / 2 - 20,
      finalCanvas.height / 2 - 20 - radius
    );
    ctx.quadraticCurveTo(
      finalCanvas.width / 2 - 20,
      finalCanvas.height / 2 - 20,
      finalCanvas.width / 2 - 20 - radius,
      finalCanvas.height / 2 - 20
    );
    ctx.lineTo(20 + radius, finalCanvas.height / 2 - 20);
    ctx.quadraticCurveTo(
      20,
      finalCanvas.height / 2 - 20,
      20,
      finalCanvas.height / 2 - 20 - radius
    );
    ctx.lineTo(20, 20 + radius);
    ctx.quadraticCurveTo(20, 20, 20 + radius, 20);
    ctx.closePath();
    ctx.stroke();

    ctx.shadowColor = "rgba(0, 0, 0, 0.2)";
    ctx.shadowBlur = 10;
    ctx.shadowOffsetX = 5;
    ctx.shadowOffsetY = 5;

    const qrImage = new Image();
    qrImage.src = qrDataUrl;
    qrImage.onload = () => {
      ctx.drawImage(qrImage, qrX, qrY, qrSize, qrSize);

      const logoImage = new Image();
      logoImage.src = logoSrc;
      logoImage.onload = () => {
        const logoWidth = 140;
        const logoHeight = 60;
        const logoX = 50;
        const logoY = 50;
        ctx.drawImage(logoImage, logoX, logoY, logoWidth, logoHeight);

        ctx.textAlign = "center";
        ctx.font = '28px "Montserrat", sans-serif';
        ctx.fillStyle = "#007272";
        ctx.fillText(
          "Thank you for your contribution!",
          finalCanvas.width / 4,
          qrY + qrSize + 80
        );

        const finalDataUrl = finalCanvas.toDataURL("image/png");
        const downloadLink = document.createElement("a");
        downloadLink.href = finalDataUrl;
        downloadLink.download = `Add Information: ${
          eventDetails?.eventName || "Event"
        }.png`;
        downloadLink.click();
      };
    };
  };

  const copyLink = () => {
    navigator.clipboard.writeText(link).then(() => {
      setToast(true);
      setTimeout(() => setToast(false), 3000);
    });
  };

  const handleEmailResponse = (response) => {
    if (response === "yes") {
      navigate("summary", {
        state: { type: "Invite" },
      });
    } else {
      navigate("uploadsummary");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!eventDetails) {
          throw new Error("Event details not available");
        }

        const eventId = eventDetails.eventId;
        const data = await isAttendeeDetailsInitiated(eventId);
        setsummaryData(data);
        console.log("API response:", data);

        if (data.message === "") {
          console.log("No message, showing summary component.");
          setShowSummary(true);
        } else {
          console.log("Message is present, showing upload section.");
          setShowSummary(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setErrorMessage("Error fetching data. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [eventDetails]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (errorMessage) {
    return <div>Error: {errorMessage}</div>;
  }

  const isAttendee = eventDetails?.myRole === "Attendee";
  if (isAttendee) {
    return (
      <div className="access-restricted">
        <p style={{ fontSize: "25px", color: "#007272" }}>
          Access Restricted to Event Managers Only
        </p>
        <p style={{ fontSize: "30px", color: "#007272" }}>
          Please fill your details in the{" "}
          <strong>
            <span style={{ color: "#000000" }}>"INDIVIDUAL"</span>
          </strong>{" "}
          Tab
        </p>
      </div>
    );
  } else {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="attendee-details">
              {showSummary ? (
                <SummaryComponent summaryData={summaryData} />
              ) : (
                <>
                  <h1 className="page-title">
                    🧾 Attendee Travel Information Collection
                  </h1>
                  <p className="page-description">
                    Track attendees' travel details for accurate carbon emission
                    calculations.
                  </p>
                  <p>
                    <strong>
                      How would you like to collect travel details?
                    </strong>
                  </p>

                  <div className="options-grid">
                    <div className="option">
                      <div className="option-content">
                        <h3> Upload Attendee List</h3>
                        <p>
                          Upload an Excel sheet with <em>Name</em> and{" "}
                          <em>Email ID</em>. Each attendee automatically gets an
                          email link to fill in their travel details.
                        </p>
                      </div>
                      <div className="option-action mt-auto">
                        <button
                          className="btn GreenBtn"
                          onClick={() =>
                            navigate("summary", { state: { type: "Invite" } })
                          }
                        >
                          ⬆ Upload Attendee List
                        </button>
                      </div>
                    </div>

                    <div className="option">
                      <div className="option-content">
                        <h3>Share a Direct Link</h3>
                        <p>
                          Copy a form link to share via WhatsApp, Telegram, or
                          Email. Great for pre-event groups and online
                          communities.
                        </p>
                      </div>
                      <div className="option-action mt-auto">
                        <button className="copy-button" onClick={copyLink}>
                          <FaRegCopy className="copy-icon" /> Copy Link
                        </button>
                      </div>
                    </div>

                    <div className="option">
                      <div className="option-content">
                        <h3>Use a QR Code at the Event</h3>
                        <p>
                          Download a printable QR code to display at the
                          registration desk. Attendees scan it and submit travel
                          details on the spot.
                        </p>
                      </div>
                      <div className="option-action mt-auto">
                        <div ref={canvasRef} style={{ display: "none" }}>
                          <QRCodeCanvas
                            value={link}
                            size={128}
                            level="M"
                            includeMargin={true}
                          />
                        </div>
                        <button
                          className="downloadQR-button"
                          onClick={generateImage}
                        >
                          <BsDownload className="download-icon" /> Download QR
                          Code
                        </button>
                      </div>
                    </div>
                    <div className="option">
                      <div className="option-content">
                        <h3>Fill in Summary Directly</h3>
                        <p>
                          As the Event Manager, you can directly fill in the
                          travel details on behalf of your attendees. This
                          option is ideal when a limited number of attendees
                          have submitted their information, allowing you to
                          ensure completeness of data for accurate carbon
                          tracking.
                        </p>
                      </div>
                      <div className="option-action mt-auto">
                        <button
                          className="btn GreenBtn"
                          onClick={() => navigate("uploadsummary")}
                        >
                          ✍️ Fill in Summary Directly
                        </button>
                      </div>
                    </div>
                  </div>

                  <p className="mt-4">
                    💡 You can use any or all of these methods in parallel for
                    maximum data collection.
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        {toast && (
          <div className="eco-toast__wrapper">
            <div className="eco-toast">
              <div className="eco-toast__body">Link copied!</div>
            </div>
          </div>
        )}
      </div>
    );
  }
};

export default AttendeeConfirmation;
